import { createContext, useContext } from 'react';

const SSRDataContext = createContext(null);

export const SSRDataProvider = SSRDataContext.Provider;

export const useSSRData = () => useContext(SSRDataContext);
